/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/currency';
import '../bills/tender';
import '../bank-accounts/bank_accounts';
import '../common/fee';
import '../common/time';
import '../simple_instrument_store/model';
import '../common/countries';
import '../panhandler/service';
import '../common/tender';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "ledger": {
        "nested": {
          "service": {
            "nested": {
              "InstantDepositInfo": {
                "fields": {
                  "depositAmount": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "feeAmount": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "card": {
                    "type": ".squareup.bills.CardTender.Card",
                    "id": 3,
                    "rule": "optional"
                  },
                  "bankAccount": {
                    "type": ".squareup.bank_accounts.BankAccount",
                    "id": 4,
                    "rule": "optional"
                  },
                  "depositBeforeFeeAmount": {
                    "type": ".squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "feeApplied": {
                    "type": ".squareup.common.Fee",
                    "id": 6,
                    "rule": "optional"
                  },
                  "feesApplied": {
                    "type": ".squareup.ledger.service.Fee",
                    "id": 7,
                    "rule": "optional"
                  },
                  "moneyTransferServerToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "Fee": {
                "fields": {
                  "feeBasisPoints": {
                    "type": "uint32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "feeAmount": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "InstantDepositMerchant": {
                "nested": {
                  "ApprovalState": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "UNAPPROVED": 1,
                      "APPROVED": 2
                    }
                  }
                }
              },
              "EligibilityBlocker": {
                "values": {
                  "UNKNOWN": 0,
                  "NOT_ONBOARDED": 1,
                  "NO_FUNDING_SOURCE": 2,
                  "INSUFFICIENT_FUNDS": 3,
                  "UNSETTLEABLE": 4,
                  "OVER_DEPOSIT_LIMIT": 5,
                  "OVER_DAILY_DEPOSIT_LIMIT": 14,
                  "NOT_APPROVED": 6,
                  "EXCEEDS_DEPOSIT_LIMIT": 7,
                  "NO_BANK_ACCOUNT": 8,
                  "UNVERIFIED_FUNDING_SOURCE": 9,
                  "INSUFFICIENT_PAYMENT_ACTIVITY": 10,
                  "FUNDING_SOURCE_VERIFICATION_EXPIRED": 11,
                  "FUNDING_SOURCE_UNSUPPORTED": 12,
                  "INSTANT_DEPOSIT_UNAVAILABLE": 13
                }
              },
              "MoneyMovingBlocker": {
                "values": {
                  "DEFAULT_UNKNOWN": 0,
                  "CARD_EXPIRED": 1,
                  "CARD_DECLINED": 2,
                  "INCORRECT_EXPECTED_DEPOSIT_AMOUNT": 3,
                  "INSUFFICIENT_FUNDS_ON_INSTRUMENT": 4,
                  "GENERIC_FAILURE": 5,
                  "EXTERNAL_TRANSACTION_LIMIT": 6
                }
              },
              "GetInstantDepositAccountResponse": {
                "fields": {
                  "linkedCard": {
                    "type": ".squareup.ledger.service.GetInstantDepositAccountResponse.LinkedCard",
                    "id": 1,
                    "rule": "optional"
                  },
                  "feeAmount": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "feeBasisPoints": {
                    "type": "uint32",
                    "id": 3,
                    "rule": "optional"
                  },
                  "instantDepositFee": {
                    "type": ".squareup.ledger.service.FeeStructure",
                    "id": 6,
                    "rule": "optional"
                  },
                  "sameDayDepositFee": {
                    "type": ".squareup.ledger.service.FeeStructure",
                    "id": 7,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "CardStatus": {
                    "values": {
                      "UNKNOWN": 0,
                      "VERIFIED": 1,
                      "FAILED": 2,
                      "VERIFICATION_PENDING": 3,
                      "VERIFICATION_EXPIRED": 4
                    }
                  },
                  "LinkedCard": {
                    "fields": {
                      "cardDetails": {
                        "type": ".squareup.bills.CardTender.Card",
                        "id": 1,
                        "rule": "optional"
                      },
                      "cardStatus": {
                        "type": ".squareup.ledger.service.GetInstantDepositAccountResponse.CardStatus",
                        "id": 2,
                        "rule": "optional"
                      },
                      "clientToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "instrumentToken": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "linkCardFailureStatus": {
                        "type": ".squareup.ledger.service.LinkCardResponse.State",
                        "id": 5,
                        "rule": "optional"
                      },
                      "createdAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 6,
                        "rule": "optional"
                      },
                      "deactivatedAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 7,
                        "rule": "optional"
                      },
                      "confirmationCode": {
                        "type": "string",
                        "id": 8,
                        "rule": "optional"
                      },
                      "confirmationCodeExpiresAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 9,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "FeeStructure": {
                "fields": {
                  "feeBasisPoints": {
                    "type": "uint32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "feeAmount": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "minimumFeeAmount": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "minimumFeeDepositLimit": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "LinkCardRequest": {
                "fields": {
                  "idempotenceKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "browserInteraction": {
                    "type": ".squareup.simple_instrument_store.BrowserInteraction",
                    "id": 4,
                    "rule": "optional"
                  },
                  "skipVerificationEmail": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "loggableSessionToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "country": {
                    "type": ".squareup.common.countries.Country",
                    "id": 7,
                    "rule": "optional"
                  },
                  "serverEncryptedTender": {
                    "type": ".squareup.panhandler.service.ServerEncryptedTender",
                    "id": 9,
                    "rule": "optional"
                  },
                  "stepUpAuthenticationSatisfied": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "linkedCard": {
                    "type": ".squareup.common.tender.CardTender",
                    "id": 3
                  },
                  "cardNonceData": {
                    "type": ".squareup.ledger.service.CardNonceData",
                    "id": 8
                  }
                },
                "nested": {
                  "card_data": {
                    "oneof": ["linkedCard", "cardNonceData"]
                  }
                }
              },
              "LinkCardResponse": {
                "fields": {
                  "state": {
                    "type": ".squareup.ledger.service.LinkCardResponse.State",
                    "id": 1,
                    "rule": "optional"
                  },
                  "instrumentToken": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "confirmationCode": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "panSuffix": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "sendVerificationEmail": {
                    "type": "bool",
                    "id": 13,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                },
                "nested": {
                  "State": {
                    "values": {
                      "UNKNOWN": 0,
                      "LINKED": 1,
                      "UNSUPPORTED": 2,
                      "EXPIRED": 3,
                      "INVALID_PAN": 4,
                      "INVALID_CVV": 5,
                      "INVALID_POSTAL_CODE": 6,
                      "TOO_MANY_CARD_LINK_ATTEMPTS": 7,
                      "VERIFICATION_PENDING": 8,
                      "UNSUPPORTED_SQUARE_CARD": 9
                    }
                  }
                }
              },
              "EligibleForInstantDepositRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "alwaysShowUnsettleableBlockers": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "EligibleForInstantDepositResponse": {
                "fields": {
                  "proposedDepositInfo": {
                    "type": ".squareup.ledger.service.InstantDepositInfo",
                    "id": 1,
                    "rule": "optional"
                  },
                  "eligibilityBlocker": {
                    "type": ".squareup.ledger.service.EligibilityBlocker",
                    "id": 2,
                    "rule": "optional"
                  },
                  "maximumDepositAmount": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "minimumDepositAmount": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "balance": {
                    "type": ".squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "approvalState": {
                    "type": ".squareup.ledger.service.InstantDepositMerchant.ApprovalState",
                    "id": 6,
                    "rule": "optional"
                  },
                  "baseFee": {
                    "type": ".squareup.ledger.service.Fee",
                    "id": 7,
                    "rule": "optional"
                  },
                  "showPriceChangeModal": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  },
                  "showInstrumentChangedScreen": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional"
                  },
                  "sameDayDepositBaseFee": {
                    "type": ".squareup.ledger.service.Fee",
                    "id": 10,
                    "rule": "optional"
                  },
                  "instantDepositBaseFee": {
                    "type": ".squareup.ledger.service.Fee",
                    "id": 11,
                    "rule": "optional"
                  }
                }
              },
              "VerifyCardChangeRequest": {
                "fields": {
                  "verificationToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "VerifyCardChangeResponse": {
                "fields": {
                  "responseCode": {
                    "type": ".squareup.ledger.service.VerifyCardChangeResponse.ResponseCode",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ResponseCode": {
                    "values": {
                      "UNKNOWN": 0,
                      "LINKED": 1,
                      "CODE_INVALID": 2,
                      "CODE_EXPIRED": 3,
                      "MERCHANT_TOKEN_MISMATCH": 4
                    }
                  }
                }
              },
              "ResendVerificationEmailRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ResendVerificationEmailResponse": {
                "fields": {
                  "state": {
                    "type": ".squareup.ledger.service.ResendVerificationEmailResponse.VerificationEmailState",
                    "id": 1,
                    "rule": "optional"
                  },
                  "confirmationCode": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "panSuffix": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "sendVerificationEmail": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                },
                "nested": {
                  "VerificationEmailState": {
                    "values": {
                      "UNKNOWN": 0,
                      "SENT": 1,
                      "ALREADY_VERIFIED": 2
                    }
                  }
                }
              },
              "CardNonceData": {
                "fields": {
                  "cardNonce": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "verificationToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "applicationId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.InstantDepositInfo && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.Fee && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.InstantDepositMerchant?.nested?.ApprovalState && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.EligibilityBlocker && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.MoneyMovingBlocker && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.GetInstantDepositAccountResponse && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.GetInstantDepositAccountResponse?.nested?.CardStatus && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.GetInstantDepositAccountResponse?.nested?.LinkedCard && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.FeeStructure && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.LinkCardRequest && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.LinkCardResponse && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.LinkCardResponse?.nested?.State && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.EligibleForInstantDepositRequest && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.EligibleForInstantDepositResponse && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.VerifyCardChangeRequest && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.VerifyCardChangeResponse && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.VerifyCardChangeResponse?.nested?.ResponseCode && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.ResendVerificationEmailRequest && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.ResendVerificationEmailResponse && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.ResendVerificationEmailResponse?.nested?.VerificationEmailState && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.CardNonceData) {
  $root.addJSON(jsonData);
}

/**
 * Information about either a potential Instant Deposit or a successfully sent Instant Deposit.
 *
 * SOURCE InstantDepositInfo @ squareup/instant-deposit/instant_deposits.proto at 28:1
 */
export const InstantDepositInfo = $root.lookupType('squareup.ledger.service.InstantDepositInfo');
fixType(InstantDepositInfo);
Builder.createAndAttachToType(InstantDepositInfo);
/**
 * SOURCE Fee @ squareup/instant-deposit/instant_deposits.proto at 74:1
 */
export const Fee = $root.lookupType('squareup.ledger.service.Fee');
fixType(Fee);
Builder.createAndAttachToType(Fee);
/**
 * An instant deposit merchant in Ledger.
 *
 * SOURCE InstantDepositMerchant @ squareup/instant-deposit/instant_deposits.proto at 87:1
 */
export const InstantDepositMerchant = {};
/**
 * The approval state of the instant deposit merchant as determined by Risk Systems.
 *
 * SOURCE ApprovalState @ squareup/instant-deposit/instant_deposits.proto at 89:3
 */
InstantDepositMerchant.ApprovalState = $root.lookupEnum('squareup.ledger.service.InstantDepositMerchant.ApprovalState').values;
/**
 * Reasons why a merchant cannot currently accept an instant deposit.
 *
 * SOURCE EligibilityBlocker @ squareup/instant-deposit/instant_deposits.proto at 139:1
 */
export const EligibilityBlocker = $root.lookupEnum('squareup.ledger.service.EligibilityBlocker').values;
/**
 * Reasons why an attempted instant deposit failed.
 *
 * SOURCE MoneyMovingBlocker @ squareup/instant-deposit/instant_deposits.proto at 197:1
 */
export const MoneyMovingBlocker = $root.lookupEnum('squareup.ledger.service.MoneyMovingBlocker').values;
/**
 * The response to a GetInstantDepositAccountRequest request
 *
 * SOURCE GetInstantDepositAccountResponse @ squareup/instant-deposit/instant_deposits.proto at 269:1
 */
export const GetInstantDepositAccountResponse = $root.lookupType('squareup.ledger.service.GetInstantDepositAccountResponse');
fixType(GetInstantDepositAccountResponse);
Builder.createAndAttachToType(GetInstantDepositAccountResponse);
/**
 * Status of card linked to an instant deposit account.
 * The enum is APPEND ONLY, as these values are persisted in DB.
 *
 * SOURCE CardStatus @ squareup/instant-deposit/instant_deposits.proto at 274:3
 */
GetInstantDepositAccountResponse.CardStatus = $root.lookupEnum('squareup.ledger.service.GetInstantDepositAccountResponse.CardStatus').values;
/**
 * SOURCE LinkedCard @ squareup/instant-deposit/instant_deposits.proto at 291:3
 */
GetInstantDepositAccountResponse.LinkedCard = $root.lookupType('squareup.ledger.service.GetInstantDepositAccountResponse.LinkedCard');
fixType(GetInstantDepositAccountResponse.LinkedCard, {
  cardDetails: {
    required: true
  },
  cardStatus: {
    required: true
  }
});
Builder.createAndAttachToType(GetInstantDepositAccountResponse.LinkedCard);
/**
 * Fee pricing structure for instant and same-day deposit
 *
 * SOURCE FeeStructure @ squareup/instant-deposit/instant_deposits.proto at 362:1
 */
export const FeeStructure = $root.lookupType('squareup.ledger.service.FeeStructure');
fixType(FeeStructure);
Builder.createAndAttachToType(FeeStructure);
/**
 * A request to link a payment card.
 *
 * SOURCE LinkCardRequest @ squareup/instant-deposit/instant_deposits.proto at 395:1
 */
export const LinkCardRequest = $root.lookupType('squareup.ledger.service.LinkCardRequest');
fixType(LinkCardRequest, {
  idempotenceKey: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(LinkCardRequest);
/**
 * The response to a LinkCardRequest
 *
 * SOURCE LinkCardResponse @ squareup/instant-deposit/instant_deposits.proto at 448:1
 */
export const LinkCardResponse = $root.lookupType('squareup.ledger.service.LinkCardResponse');
fixType(LinkCardResponse, {
  state: {
    required: true
  }
});
Builder.createAndAttachToType(LinkCardResponse);
/**
 * The various states a card can be in
 *
 * SOURCE State @ squareup/instant-deposit/instant_deposits.proto at 453:3
 */
LinkCardResponse.State = $root.lookupEnum('squareup.ledger.service.LinkCardResponse.State').values;
/**
 * A request to check if a merchant is currently eligible for an instant deposit.
 *
 * SOURCE EligibleForInstantDepositRequest @ squareup/instant-deposit/instant_deposits.proto at 502:1
 */
export const EligibleForInstantDepositRequest = $root.lookupType('squareup.ledger.service.EligibleForInstantDepositRequest');
fixType(EligibleForInstantDepositRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(EligibleForInstantDepositRequest);
/**
 * Response to an eligibility check. One and only one of deposit_info or blocker is set.
 *
 * SOURCE EligibleForInstantDepositResponse @ squareup/instant-deposit/instant_deposits.proto at 515:1
 */
export const EligibleForInstantDepositResponse = $root.lookupType('squareup.ledger.service.EligibleForInstantDepositResponse');
fixType(EligibleForInstantDepositResponse);
Builder.createAndAttachToType(EligibleForInstantDepositResponse);
/**
 * A request to verify a payment card change.
 *
 * SOURCE VerifyCardChangeRequest @ squareup/instant-deposit/instant_deposits.proto at 711:1
 */
export const VerifyCardChangeRequest = $root.lookupType('squareup.ledger.service.VerifyCardChangeRequest');
fixType(VerifyCardChangeRequest, {
  verificationToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(VerifyCardChangeRequest);
/**
 * The response to a VerifyLinkedCardRequest
 *
 * SOURCE VerifyCardChangeResponse @ squareup/instant-deposit/instant_deposits.proto at 725:1
 */
export const VerifyCardChangeResponse = $root.lookupType('squareup.ledger.service.VerifyCardChangeResponse');
fixType(VerifyCardChangeResponse, {
  responseCode: {
    required: true
  }
});
Builder.createAndAttachToType(VerifyCardChangeResponse);
/**
 * SOURCE ResponseCode @ squareup/instant-deposit/instant_deposits.proto at 732:3
 */
VerifyCardChangeResponse.ResponseCode = $root.lookupEnum('squareup.ledger.service.VerifyCardChangeResponse.ResponseCode').values;
/**
 * SOURCE ResendVerificationEmailRequest @ squareup/instant-deposit/instant_deposits.proto at 750:1
 */
export const ResendVerificationEmailRequest = $root.lookupType('squareup.ledger.service.ResendVerificationEmailRequest');
fixType(ResendVerificationEmailRequest);
Builder.createAndAttachToType(ResendVerificationEmailRequest);
/**
 * SOURCE ResendVerificationEmailResponse @ squareup/instant-deposit/instant_deposits.proto at 757:1
 */
export const ResendVerificationEmailResponse = $root.lookupType('squareup.ledger.service.ResendVerificationEmailResponse');
fixType(ResendVerificationEmailResponse, {
  state: {
    required: true
  }
});
Builder.createAndAttachToType(ResendVerificationEmailResponse);
/**
 * SOURCE VerificationEmailState @ squareup/instant-deposit/instant_deposits.proto at 758:3
 */
ResendVerificationEmailResponse.VerificationEmailState = $root.lookupEnum('squareup.ledger.service.ResendVerificationEmailResponse.VerificationEmailState').values;
/**
 * SOURCE CardNonceData @ squareup/instant-deposit/instant_deposits.proto at 782:1
 */
export const CardNonceData = $root.lookupType('squareup.ledger.service.CardNonceData');
fixType(CardNonceData, {
  cardNonce: {
    notEmpty: true
  },
  verificationToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CardNonceData);